import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-2 px-6 py-12 text-center", className)}>
      {Icon && (
        <div className="grid h-9 w-9 place-items-center rounded-md bg-surface-muted text-ink-muted">
          <Icon className="h-4 w-4" strokeWidth={1.75} />
        </div>
      )}
      <p className="text-md font-medium text-ink">{title}</p>
      {description && <p className="text-sm text-ink-muted max-w-prose">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export function ErrorState({
  title = "Something went wrong",
  description,
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
      <p className="text-md font-medium text-ink">{title}</p>
      {description && <p className="text-sm text-danger max-w-prose">{description}</p>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 text-sm text-accent underline-offset-4 hover:underline"
        >
          Try again
        </button>
      )}
    </div>
  );
}
